export default __webpack_public_path__ + "static/uOfT-6305c5368d6f133ecccd035891d35286.png";